var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C11.7812 4 13.375 4.78125 14.4688 6H13C12.4375 6 12 6.4375 12 7C12 7.5625 12.4375 8 13 8H17C17.5625 8 18 7.5625 18 7V3C18 2.4375 17.5625 2 17 2C16.4375 2 16 2.4375 16 3V4.71875C14.5312 3.0625 12.375 2 10 2C5.59375 2 2 5.59375 2 10C2 14.4062 5.59375 18 10 18C12.7188 18 15.125 16.6562 16.5625 14.5625C16.875 14.125 16.7812 13.5 16.3125 13.1875C15.875 12.875 15.25 12.9688 14.9375 13.4375C13.8438 14.9688 12.0312 16 10 16C6.6875 16 4 13.3125 4 10C4 6.6875 6.6875 4 10 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate_right.e221333f3ea9b9c8555faed862e51998.svg";
export { ForwardRef as ReactComponent };